import instance from "./instance";

const categoryUrl = "category/v1/user";

export const getListComplexity = (token) => {
  // checkAndCallDailyLoginAPI()
  return instance.get(`${categoryUrl}/complexity/get-complexity-category`);
};
